import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  HostListener,
  OnDestroy,
  ViewContainerRef,
  ViewChild,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommonService } from '../services/common.service';
import { Router, Event, NavigationEnd } from '@angular/router';
import { UtilService } from 'src/app/util/util.service';
import { Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { EventTrackerService } from '../services/event-tracker.service';
import { SCAN_QR_ICON , FEATURE,FMH_LOAN_LOGO, CASH_DRAWER_LOGO, DYNAMIC_QR_LOGO} from 'src/defaultImages.js';
import { LocalStorageService } from '../services/localStorage.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { PineLabsMergePopupEnum } from '../enums/pinelabs.enum';
import { PineLabService } from '../services/pine-lab.service';
import { ActionPromtService } from '../services/action-promt.service';
import { PermissionsEnum } from '../enums/permissions.enum';
import { LoanService } from 'src/app/order/loan.service';
import { SetupBillingCounterModalType } from '../enums/billing-counter.enum';
import { ApiService } from '../services/api.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { LoanDetails } from 'src/app/order/order.interface';
import { BillingCountersDataService } from '../services/billing-counters-data.service';
import { CartModalComponent } from 'src/app/pos-order/modals/cart-modal/cart-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { DateService } from '../services/date.service';
import { MessageService } from '../services/message.service';
import { LanguageService } from '../services/language.service';
import { country } from '../enums/language';
import {
  SUPPORT_OPERATING_HOURS_NOTICE_STORAGE_KEY,
  isSupportOperatingHoursNoticeWindowNow,
} from '../components/support-operating-hours-notice/support-operating-hours-notice.config';
import {
  APP_UPDATE_NOTICE_STORAGE_KEY,
  REQUIRED_APP_VERSION,
  isAppVersionBelowRequired,
  isIosPartnerApp,
} from '../components/app-update-notice/app-update-notice.config';
import { global_app_settings } from 'src/app/constants/global-app-settings';
import { PrintService } from '../services/print.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  readonly global_app_settings = global_app_settings;
  images: any = {
    FMH_LOAN_LOGO:FMH_LOAN_LOGO,
    SCAN_QR_ICON: SCAN_QR_ICON,
    FEATURE : FEATURE,
    CASH_DRAWER_LOGO: CASH_DRAWER_LOGO,
    DYNAMIC_QR_LOGO: DYNAMIC_QR_LOGO
  };
  modalWidth: string;
  activeRoute: string;
  private ngUnsubscribe = new Subject();
  showScanQrAd: boolean;
  enum = {
    permission: PermissionsEnum,
    billingCounter: SetupBillingCounterModalType
  };
  isCountersLoading: boolean = false;
  subscription = new Subscription();
  billingCounterName: string = '';
  availableFloors:Array<any> = [];
  showDynamicQr:boolean= false;
  translationText;
  isFoodCourt:boolean =false;
  lhdnFormFilled:boolean = false;
  isMalaysia:boolean = false;

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private _bottomSheet: MatBottomSheet,
    private router: Router,
    public util: UtilService,
    private _eventTracker: EventTrackerService,
    private localStorage: LocalStorageService,
    private curr: CurrencyService,
    private _pineLabService: PineLabService,
    private _actionService: ActionPromtService,
    private _loanService : LoanService,
    private _apiService : ApiService,
    private _modalService : NzModalService,
    private _counterDataService: BillingCountersDataService,
    private _translateService: TranslateService,
    private _msgService: MessageService,
    private _dateService: DateService,
    private _languageService: LanguageService,
    private _printService: PrintService
  ) {
    this.Currency = this.curr.getCurrency();
    this.showScanQrAd = this.util.showScanQrAd()
    this.onResize(event);
    this.commonService.merge$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((m: any) => {
        this.handleMerge(m);
      });
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.url;
      }
    });
    this.isMalaysia = this._languageService.getDomain() === country.ai.domain;
  }

  @ViewChild('printerStatusRef', { read: ViewContainerRef, static: true })
  printerStatusRef: ViewContainerRef;
  isButton = 0;
  isMerge: boolean = false;
  mergeList: any = [];
  Currency;
  eeTotalEarnings: number;
  pricing: boolean = false;
  analyticsData = [];
  isEEvalueVisible: boolean = false;
  isMobile: boolean = false;
  @Input() headerTitle: string;
  @Input() headerButtonText: string;
  @Input('showCashDrawerButton') isCashDrawerVisible: boolean;
  @Input('showEEvalue') isEEvalue: boolean;
  loanBtnData:any = {};
  loanButtonText: string = '';

  // @Input() mergeList :any;
  @Output() headerButtonClicked = new EventEmitter();
  @Output() posOrder: EventEmitter<any> = new EventEmitter();
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    let innerWidth = window.innerWidth;
    if (innerWidth < 768) {
      // this.modalPosition = {left : '0%',top : '0%'};
      this.modalWidth = '100vw !important';
      this.isMobile = true;
    } else {
      // this.modalPosition = {left : '35%',top : '5%'};
      this.modalWidth = '80vw !important';
      this.isMobile = false;
    }
  }
  header_button_clicked() {
    this.headerButtonClicked.emit();
  }

  ngOnInit() {
    this.pricing = this.util.litePricing();
    this.eeTotalEarnings = +this.localStorage.get('eeTotalEarnings');
    this.lhdnFormFilled = !!this.localStorage.get('lhdn_form_filled');
    this.analyticsData = this.util.getAnalyticsData();
    if(this.isMalaysia){
      this.openLhdnForm();
    }
    this.isEEvalueVisible =
      (this.analyticsData || []).length !== 0 &&
      this.eeTotalEarnings !== 0 &&
      !this.pricing &&
      !this.isMobile &&
      this.isEEvalue &&
      !this.isHideEEValueFromRetool();
      this.showModal();
      this.showSupportOperatingHoursNoticeOnce();
      this.showAppUpdateNoticeOnce();
      this.loanBannerDetails();
    // Check if it's the next day, reset the popup state
     const lastVisitDate = localStorage.getItem('lastVisitDate');
     const today = new Date().toLocaleDateString();
 
     if (lastVisitDate !== today && this.showScanQrAd) {
       this.openScanQrAdModal();
       this.localStorage.set('lastVisitDate',today);
     }
    this.setTranslations();
    this.getBillingCounterName();
    this.isFoodCourt = this.localStorage.get('foodcourt') ? true : false;
    this.localStorage.watch('restaurant_settings')
    .pipe(
      filter(value => value !== null), 
      distinctUntilChanged()
    )
    .subscribe((value) => {
      const restSetting = JSON.parse(value || '{}');
      this.showDynamicQr = restSetting?.global?.qr_ordering_plan ?? false;
    });
    this.localStorage.watch('lhdn_form_filled')
    .pipe(
      filter(value => value !== null),
      distinctUntilChanged()
    )
    .subscribe((value) => {
      this.lhdnFormFilled = !!value;
    });
  }
  private setTranslations():void{
    this.subscription.add(this._translateService.get(['ORDER_DASHBOARD']).subscribe((translation) => {
      this.translationText = translation.ORDER_DASHBOARD;
    }));
    this.loanBannerDetails();
  }

  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          this.billingCounterName = mappedCounterName;
        })
    );
  }
  async checkImageExists(url: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  }
  async showModal(){
    const imageExists = await this.checkImageExists(this.images.FEATURE);
    const isMalaysia = this._languageService.getDomain() === country.ai.domain;
    const isOrderDashboard = this.activeRoute === '/orders';
    if (
      this.shouldShowAdModal() &&
      imageExists &&
      isMalaysia &&
      isOrderDashboard
    ) {
      this.openNewAdModal();
    }
  }

  shouldShowAdModal(): boolean {
    const adDateStr = this.localStorage.get('ad_date');
    if (!adDateStr) return true;
  
    const lastShown = new Date(adDateStr);
    const now = new Date();
    const diffInDays = this._dateService.differenceInCalendarDays(now, lastShown);
  
    return diffInDays >= 7;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.subscription?.unsubscribe();
  }
  ngOnChanges(changes: SimpleChanges) {
    if ('headerButtonText' in changes) {
      this.isBtn();
    }
  }

  isHideEEValueFromRetool() {
    // Hide EE value based on Retool settings 'Hide Earnings on Online Order Dashboard'
    // By default the setting will be enabled for all existing merchants and in new restaurant    creation script
    const settings = JSON.parse(localStorage.getItem('restaurant_settings'));
    const hideEEValue = !!((settings || {}).global || {})
      .hide_ee_value_addition;
    return hideEEValue;
  }

  isBtn() {
    if (this.headerButtonText === '' || this.headerButtonText === undefined) {
      this.isButton = 0;
    } else {
      this.isButton = 1;
    }
  }
  handleMerge(m) {
    if (
      m.topic == 'mergelist_from_orderleft' ||
      m.topic == 'mergelist_from_order' ||
      m.topic == 'mergelist_from_header'
    ) {
      this.mergeList = m.data;
      if (this.mergeList.length >= 2) this.isMerge = true;
      else this.isMerge = false;
    }
  }
  async openDialog() {
    this.util.clearUserInformation();
    this.headerButtonClicked.emit();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.position = { right: '10px' };
    if (
      this.headerButtonText == '+ Create New Order' ||
      this.headerButtonText == '+ Buat Pesanan Baru'
    ) {
      this.setPosFormStatus();
      if(this.util.skipOrderTypeModal()) {
        this.util.setDefaultDataForSkipOrderType();
        this.router.navigate(['/pos/order']);
      } else {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        const { OrderTypeComponent } = await import(
          /* webpackPrefetch: true */ 'src/app/pos-order/modals/order-type/order-type.component'
        );
        this.dialog.open(OrderTypeComponent, {
          backdropClass: 'backdrop',
          data: {
            status: {
              orderTypeShow: 1,
              userDetailShow: 0,
              tableShow: 0,
            },
            from: 'order',
          },
          maxHeight: '100vh',
        });
      }
      this._eventTracker.easyeat_track_event('CREATE_NEW_ORDER', {
        'Order Source': 'POS',
      });
      this._eventTracker.easyeat_track_event('CREATE_NEW_ORDER', {
        create_new_order: true,
      });
    }
  }
  async openMobDialog() {
    localStorage.setItem('pos_order_id', '');
    this.setPosFormStatus();
    this.util.clearCartData();
    if(this.util.skipOrderTypeModal()) {
      this.setDefaultsForDirectCartPage();
      this.router.navigate(['/pos-mobile/menu']);
    } else {
      const { ChooseOrdertypeComponent } = await import(
        /* webpackPrefetch: true */ 'src/app/pos-mobile/modals/choose-ordertype/choose-ordertype.component'
      );
      const bottomSheetRef = this._bottomSheet.open(ChooseOrdertypeComponent, {
        disableClose: true,
        data: {
          from: 'order',
        },
      });
      bottomSheetRef.afterDismissed().subscribe((res: any) => {
        if (res.message == 'changed') this.router.navigate(['/pos-mobile/menu']);
      });
    }
    this._eventTracker.easyeat_track_event('CREATE_NEW_ORDER', {
      'Order Source': 'POS-M',
    });
    this._eventTracker.easyeat_track_event('CREATE_NEW_ORDER', {
      create_new_order: true,
    });
  }
  openMergeDialog() {
    this._actionService.openModal(
      this.enum.permission.CAN_SETTLE_OR_MERGE_BILL,
      (result) => {
        if (result.status == 1 && result.message == 'AUTHORIZED') {
         this.openAuthMergeDialog();
        }
      },
      (error) => {}
    );
  }
  clickLoanComponent():void{
   this._loanService.openDifferentComponent(this.loanBtnData?.isSubmit);
  }
  private loanBannerDetails() {
    if (!global_app_settings.enable_loan_feature) {
      this.loanBtnData = {};
      return;
    }
    this._loanService.openLoanBannerDetails().subscribe(
      (response: LoanDetails) => {
        this.loanBtnData = response;
        this.showPlanText();
      },
      (error: any) => {
        console.error('Error fetching loan banner details:', error);
      }
    );
  }
  showPlanText(): void {
    if (this.loanBtnData?.isMarked  && !this.loanBtnData?.isSubmit) {
      this.loanButtonText = this.translationText?.GET_CREDIT;
    } else if (this.loanBtnData?.isSubmit) {
      this.loanButtonText = this.translationText?.LOAN_STATUS;
    } else {
      this.loanButtonText = this.translationText?.GET_LOAN;
    }
}
  
  async openAuthMergeDialog() {
    const firstOrderId = this.mergeList[0];
    const orderIds = this.mergeList.slice(1,this.mergeList?.length);
    this._pineLabService.setMergePopUpOpen(PineLabsMergePopupEnum.PL_OPEN);
    const { OrderDetailsComponent } = await import(
      /* webpackPrefetch: true */
      'src/app/server/components/order-details/order-details.component'
    );
    const dialogRef = this.dialog.open(OrderDetailsComponent, {
      backdropClass: 'custom-dialog-backdrop-class',
      panelClass: 'backdrop',
      data: {
        order_id: firstOrderId,
        order_ids: orderIds,
        opened: 'orderstab',
        showQris: true,
        showDuitnow: true,
        showPineLab: true,
      },
      maxWidth: this.modalWidth,
      maxHeight: '100vh',
    });
    dialogRef.afterClosed().subscribe((result) => {
      this._pineLabService.setMergePopUpOpen(PineLabsMergePopupEnum.PL_CLOSE);
      if (result === undefined || (result || {}).event === 'close') {
        this.isMerge = true;
      } else {
        this.commonService.sendMergeIds({
          topic: 'mergelist_from_header',
          data: [],
        });
        this.isMerge = false;
      }
      result.ack && this.commonService.orderActionMessage({ action: 0 });
    });
  }

  setPosFormStatus() {
    localStorage.setItem('pos_order_type_set', '1');
    localStorage.setItem('pos_user_details_set', '0');
    localStorage.setItem('pos_order_pax_set', '0');
    localStorage.setItem('pos_table_no_set', '0');
  }

  openCashDrawer() {
    if (this.util.isMultiCashDrawerEnabled()) {
      if (!this.util.isReactDevice()) {
        this.openCashierSetupModal(this.enum.billingCounter.WARNING);
      } else if (this.billingCounterName) {
        this.openCashDrawerModal();
      } else {
        this.openCashierSetupModal(this.enum.billingCounter.SETUP_INFO);
      }
    } else {
      this.openCashDrawerModal();
    }
  }

  openLhdnForm(){
    const isLoggedIn = !!this.localStorage.get('token');
    if(!!this.localStorage.get("lhdn_first_time") || this.lhdnFormFilled || !isLoggedIn){
      return;
    }
    this.localStorage.set("lhdn_first_time", true);
    // this.openLhdnFormModal();
  }

  showDowntimeWarningOnce() {
    const isLoggedIn = !!this.localStorage.get('token');
    if (isLoggedIn && !this.localStorage.get('downtime_warning_shown')) {
      this.localStorage.set('downtime_warning_shown', 'true');
      // this.openDowntimeWarningModal();
    }
  }

  showAppUpdateNoticeOnce() {
    const isLoggedIn = !!this.localStorage.get('token');
    if (
      !isLoggedIn ||
      !isIosPartnerApp() ||
      this.localStorage.get(APP_UPDATE_NOTICE_STORAGE_KEY) ||
      !isAppVersionBelowRequired(
        this._printService.appVersion,
        REQUIRED_APP_VERSION
      )
    ) {
      return;
    }
    this.localStorage.set(APP_UPDATE_NOTICE_STORAGE_KEY, 'true');
    void this.openAppUpdateNoticeModal();
  }

  private isOrderDashboardRoute(): boolean {
    const path = (this.router.url || '').split('?')[0];
    return path === '/orders' || path === '/orders/' || path.startsWith('/orders/');
  }

  showSupportOperatingHoursNoticeOnce() {
    const isLoggedIn = !!this.localStorage.get('token');
    const key = SUPPORT_OPERATING_HOURS_NOTICE_STORAGE_KEY;
    if (
      !isLoggedIn ||
      !this.isOrderDashboardRoute() ||
      !isSupportOperatingHoursNoticeWindowNow() ||
      this.localStorage.get(key)
    ) {
      return;
    }
    this.localStorage.set(key, 'true');
    void this.openSupportOperatingHoursNoticeModal();
  }

  async openDowntimeWarningModal() {
    const { DowntimeWarningComponent } = await import(
      /* webpackPrefetch: true */ '../components/downtime-warning/downtime-warning.component'
    );
    this.dialog.open(DowntimeWarningComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      maxWidth: '540px',
      data: {},
    });
  }

  async openAppUpdateNoticeModal() {
    const { AppUpdateNoticeComponent } = await import(
      /* webpackPrefetch: true */ '../components/app-update-notice/app-update-notice.component'
    );
    this.dialog.open(AppUpdateNoticeComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      maxWidth: '540px',
      disableClose: true,
      data: {},
    });
  }

  get showAppUpdateInfoIcon(): boolean {
    return (
      !!this.localStorage.get('token') &&
      this.isOrderDashboardRoute() &&
      isIosPartnerApp() &&
      isAppVersionBelowRequired(
        this._printService.appVersion,
        REQUIRED_APP_VERSION
      )
    );
  }

  openAppUpdateNoticeFromHeader(): void {
    void this.openAppUpdateNoticeModal();
  }

  get showSupportHoursInfoIcon(): boolean {
    return (
      !!this.localStorage.get('token') &&
      this.isOrderDashboardRoute() &&
      isSupportOperatingHoursNoticeWindowNow()
    );
  }

  openSupportOperatingHoursNoticeFromHeader(): void {
    void this.openSupportOperatingHoursNoticeModal();
  }

  private async openSupportOperatingHoursNoticeModal() {
    const { SupportOperatingHoursNoticeComponent } = await import(
      /* webpackPrefetch: true */ '../components/support-operating-hours-notice/support-operating-hours-notice.component'
    );
    this.dialog.open(SupportOperatingHoursNoticeComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      maxWidth: '540px',
      data: {},
    });
  }

  // async openLhdnFormModal(){
  //   const dialogConfig = new MatDialogConfig();
  //   dialogConfig.autoFocus = true;
  //   const { LhdnModalComponent } = await import(
  //     /* webpackPrefetch: true */ '../components/lhdn-modal/lhdn-modal.component'
  //   );
  //   const dialogRef = this.dialog.open(LhdnModalComponent, {
  //     backdropClass: 'backdrop',
  //     maxHeight: '90vh',
  //     data: {},
  //     maxWidth: '580px',
  //   });

  //   dialogRef.afterClosed().subscribe((result: any) => {
  //     if(result?.data === 'lhdn_form_filled'){
  //       this.lhdnFormFilled = true;
  //     }
  //   });
  // }

  private async openCashDrawerModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const { OpenDrawerComponent } = await import(
      /* webpackPrefetch: true */ '../components/open-drawer/open-drawer.component'
    );
    const dialogRef = this.dialog.open(OpenDrawerComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      data: {},
      maxWidth: '100vw',
    });

    dialogRef.afterClosed().subscribe((result: any) => {});
    this._eventTracker.easyeat_track_event('OPEN_CASH_DRAWER', {
      User_Email_ID: localStorage.getItem('email'),
      Restaurant_ID: localStorage.getItem('restaurant_id'),
      Restaurant_Name: localStorage.getItem('restaurant_nameid'),
      open_cash_drawer: true,
    });

    this._eventTracker.easyeat_track_event('OPENED_CASH_DRAWER', {});
  }
  
  private async openCashierSetupModal(type: string) {
    const modalData = {
      type: type
    }
    const { BillingCounterSetupComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/shared modal/billing-counter-setup/billing-counter-setup.component'
    );
    this._modalService.create({
      nzClosable: false,
      nzContent: BillingCounterSetupComponent,
      nzComponentParams: {modalData},
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: 450,
      nzCentered: true,
    });
  }
  async openEEvalueModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const { EeValueComponent } = await import(
      /* webpackPrefetch: true */ '../components/ee-value/ee-value.component'
    );
    this.dialog.open(EeValueComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      data: {},
      maxWidth: '100vw',
    });
  }


  async openNewAdModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const { NewFeatureAdComponent } = await import(
      /* webpackPrefetch: true */ '../components/new-feature-ad/new-feature-ad.component'
    );
    this.dialog.open(NewFeatureAdComponent, {
      panelClass: 'scan-qr-ad-modal',
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      data: {image : this.images.FEATURE},
      maxWidth: '75vw',
    });
  }
  getDineInFloors():void{
    this._apiService.getAllAvailableFloorsAndTables(null, 1).subscribe(
      (response) => {
        this.availableFloors = response['data']?.floors || [];
        this.availableFloors = this.availableFloors.filter((floor) => floor?.floor_id !== 'dlf');
        if(!this.availableFloors.length){
          this._msgService.showError(this.translationText.CREATE_TABLE_DINE_IN);
          return;
        }else {
          if(this.util.isMultiCashDrawerEnabled() && !this.billingCounterName){
            this._msgService.showError(this.translationText.MAP_BILLING_COUNTER);
            return;
          }else{
            this.openDineInTablesModal();
          }
        }
      },
      (error) => {
        console.error(error?.error)
      }
    );
  }
  openDineInTablesModal():void{
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.restoreFocus = false;
    this.dialog.open(CartModalComponent,{
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      maxWidth: '100vw',
      data: {
        status: {
          tableShow: 1,
          dynamicQr:1
        },
      },
    autoFocus: false, 
    restoreFocus: false 
    });
  }


  async openScanQrAdModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const { ScanQrAdComponent } = await import(
      /* webpackPrefetch: true */ '../components/scan-qr-ad/scan-qr-ad.component'
    );
    this.dialog.open(ScanQrAdComponent, {
      panelClass: 'scan-qr-ad-modal',
      backdropClass: 'backdrop',
      height:'auto',
      maxHeight: '90vh',
      data: {},
      maxWidth: '100vw',
    });
  }
  private setDefaultsForDirectCartPage(): void {
    this.localStorage.set('pos_order_type_set', '1');
    this.localStorage.set('pos_order_type', '0');
    this.localStorage.set('pos_platform', 'easyeat');
    this.localStorage.set('pos_ordertype_name', 'Dine In');
  }

}
